exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".step-two-heading .step-two-people[data-v-4e84ea3c]{display:-webkit-box;display:-ms-flexbox;display:flex;padding:0;margin:5px 0 0}.step-two-heading .step-two-people li[data-v-4e84ea3c]{font-size:16.8px;letter-spacing:0;margin-left:20px}", ""]);

// exports
